import loadjs from 'loadjs';

export class DataTableImport {
  isColReorder: boolean;
  isColResize: boolean;
  isSelect: boolean;
  isRowGroup: boolean;

  constructor() {
    this.isColReorder = false;
    this.isColResize = false;
    this.isSelect = true;
    this.isRowGroup = false;
  }


  loadExtensions(): Promise<any> {

    const datatablesExt = [
      'https://cdn.jsdelivr.net/npm/datatables.net-buttons@1.6.2/js/dataTables.buttons.min.js'
    ];

    if (this.isSelect) {
      datatablesExt.push('https://cdn.jsdelivr.net/npm/datatables.net-select@1.3.1/js/dataTables.select.min.js');
    }

    if (this.isColReorder) {
      datatablesExt.push('https://cdn.jsdelivr.net/npm/datatables.net-colreorder@1.5.2/js/dataTables.colReorder.min.js');
    }

    if (this.isRowGroup) {
      datatablesExt.push('https://cdn.jsdelivr.net/npm/datatables.net-rowgroup@1.1.2/js/dataTables.rowGroup.min.js');
    }

    return loadjs(datatablesExt, {
      returnPromise: true
    });
  }

}
